import React from 'react'
import { XMarkIcon as CloseIcon } from '@heroicons/react/24/outline'

interface DrawerHeaderProps {
  title?: string
  onClose: () => void
}

export const DrawerHeader: React.FC<DrawerHeaderProps> = ({ title, onClose }) => {
  return (
    <div className={`flex items-center ${title ? 'justify-between' : 'justify-end'} px-4 py-3 border-b border-gray-200`}>
      {title && (
        <h2 className="text-sm font-medium text-gray-900">{title}</h2>
      )}
      <button
        type="button"
        onClick={onClose}
        className="inline-flex items-center justify-center rounded-md p-2.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 transition-colors"
      >
        <span className="sr-only">Zamknij panel</span>
        <CloseIcon className="h-6 w-6" aria-hidden="true" />
      </button>
    </div>
  )
}
